import { useContext } from 'react';
import { default as AnalyticsReactContext } from '@atlaskit/analytics-next-stable-react-context';
export var useAnalyticsContext = function useAnalyticsContext() {
  return useContext(AnalyticsReactContext);
};